/*
 * Instafeed app block — relabel the bottom profile link and add a Facebook one.
 *
 * The Instafeed app renders its own anchor and, on its `instafeedAppLoaded`
 * event, overwrites the text with "@<account>". There is no app setting for
 * the wording — or for a second link — so we re-label its anchor here to match
 * the gallery section's "FOLLOW ON INSTAGRAM" button and append our own
 * "FOLLOW ON FACEBOOK" button beside it. This file is deferred, so our listener
 * is registered after the app block's inline one and therefore runs last.
 * The observer covers the case where the app re-renders its link afterwards.
 */
(function () {
  var LABEL = 'FOLLOW ON INSTAGRAM';
  var FACEBOOK_LABEL = 'FOLLOW ON FACEBOOK';
  var FACEBOOK_URL = 'https://www.facebook.com/grillkilt';

  // The app's own anchor only — never our injected Facebook button.
  var SELECTOR = '.instafeed-bottom-link-wrapper a:not([data-gk-facebook])';

  function relabel(link) {
    if (!link || link.textContent === LABEL) return;
    link.textContent = LABEL;
  }

  function relabelAll() {
    document.querySelectorAll(SELECTOR).forEach(relabel);
  }

  // Mirrors the app anchor's attributes so the shared CSS in custom.css
  // (`.instafeed-bottom-link-wrapper[data-feed-id] a`) styles both identically.
  function buildFacebookLink() {
    var link = document.createElement('a');
    link.setAttribute('data-gk-facebook', 'true');
    link.href = FACEBOOK_URL;
    link.target = '_blank';
    link.rel = 'me noopener';
    link.title = 'GRILLKILT on Facebook';
    // Deliberately NOT `icon-facebook` — that theme class injects a glyph via
    // `:before` (styles.css.liquid), which would sit inside the button label.
    link.className = 'gk-instafeed-facebook-link';
    link.textContent = FACEBOOK_LABEL;
    return link;
  }

  // The app can re-render the wrapper's contents, which would drop our button
  // or leave it ahead of the Instagram one, so re-assert both on every tick.
  function ensureFacebook(wrapper) {
    var link = wrapper.querySelector('a[data-gk-facebook]');
    if (!link) {
      wrapper.appendChild(buildFacebookLink());
      return;
    }
    // Keep it last so Instagram stays the leading button.
    if (wrapper.lastElementChild !== link) wrapper.appendChild(link);
  }

  function sync(wrapper) {
    relabel(wrapper.querySelector(SELECTOR));
    ensureFacebook(wrapper);
  }

  document.addEventListener('instafeedAppLoaded', function () {
    // Run after the app's own handler has set the text for this event.
    setTimeout(function () {
      relabelAll();
      document.querySelectorAll('.instafeed-bottom-link-wrapper').forEach(ensureFacebook);
    }, 0);
  });

  function watch() {
    document.querySelectorAll('.instafeed-bottom-link-wrapper').forEach(function (wrapper) {
      if (wrapper.dataset.gkRelabelled) return;
      wrapper.dataset.gkRelabelled = 'true';
      new MutationObserver(function () {
        sync(wrapper);
      }).observe(wrapper, { childList: true, subtree: true, characterData: true });
      sync(wrapper);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
